import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import "./App.css";
import Chat from "./Components/Home/Views/Chat";
import VRSSahayak from "./Components/Home/Views/VRSamadhanSahayak";

function App() {
	return (
		<Router>
			<Routes>
				{/* <Route path="/" element={<Navigate to="/Chat" />} /> */}

				<Route path="/Chat" element={<Chat />} />
				<Route path="/" element={<VRSSahayak />} />

				<Route path="*" element={<h1>404: Page Not Found</h1>} />
			</Routes>
		</Router>
	);
}

export default App;
